import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { Layout } from '@/components/commons';
import React from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import ToolsContent from '@/components/tools/ToolsContent';

const ToolsPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return <ToolsContent />;
};

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

ToolsPage.getLayout = (page: React.ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default ToolsPage;
